module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.0.0-194.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.0.0.md
// module id = 637
// module chunks = 381